export const setSearchedSongs = searchedSongs => {
    return {type: 'SET_SEARCHED_SONGS', payload: searchedSongs}
}